export type FeeUnit = 'seconds' | 'monetary';

export enum TimeUnits {
  Day,
  Week,
  Month,
  Year,
  None,
}
